import styles from './IppicaWithTabTableHeaders.module.scss';
import { useTranslation } from 'hooks/useLingUI';

export const IppicaWithTabTableHeaders = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.titlesRow}>
      <span className={`${styles.title} ${styles.titlePartenti}`}>{t('partenti')}</span>
      <span className={`${styles.title} ${styles.titleMontepremi}`}>{t('montepremi')}</span>
      <span className={`${styles.title} ${styles.titleDistanza}`}>{t('distanza')}</span>
      <span className={`${styles.title} ${styles.titlePista}`}>{t('pista')}</span>
      <span className={`${styles.title} ${styles.titleMeteo}`}>{t('meteo')}</span>
    </div>
  );
};
